import {html_beautify} from 'js-beautify';
import CodeEditor from '../Library/CodeEditor.js';

const FORMAT_OPTIONS = {
    indent_size:           4,
    indent_char:           ' ',
    wrap_line_length:      120,
    preserve_newlines:     true,
    max_preserve_newlines: 2,
    end_with_newline:      false,
    indent_inner_html:     false,
    extra_liners:          [],
};

const formatTextarea = textarea => {
    const editor = CodeEditor.get(textarea);

    if (!editor) {
        return;
    }

    const current   = editor.value;
    const formatted = html_beautify(current, FORMAT_OPTIONS);

    if (formatted === current) {
        return;
    }

    editor.value = formatted;
};

export const formatCode = button => {
    formatTextarea(button.closest('form').querySelector('textarea[data-line-numbers]'));
};

export const formatCodeOnShortcut = event => {
    if (!(event.metaKey || event.ctrlKey) || !event.shiftKey || event.key.toLowerCase() !== 'f') {
        return;
    }

    const textarea = document.activeElement?.closest('.line-numbered-editor')?.querySelector('textarea[data-line-numbers]');

    if (!textarea) {
        return;
    }

    event.preventDefault();

    formatTextarea(textarea);
};
